import { render, staticRenderFns } from "./MarketingEmailCreateRecipients.vue?vue&type=template&id=e907f694&scoped=true"
import script from "./MarketingEmailCreateRecipients.vue?vue&type=script&lang=js"
export * from "./MarketingEmailCreateRecipients.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailCreateRecipients.vue?vue&type=style&index=0&id=e907f694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e907f694",
  null
  
)

export default component.exports